import { useCallback, useMemo } from 'react';
import {
  SetShopFilterParamType,
  SetShopSortParamType,
  ShopFilterType,
} from '../state/types';
import { defaultShopSortOption } from '../content/shop.content';
import { parseFilter } from '../utils/shop.utils';
import { useLocation, useNavigate } from 'react-router-dom';

const useShopRouteParams = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const filter = searchParams.get('type') || undefined;
  const sort = searchParams.get('sort') || undefined;

  const setSearchParam = useCallback(
    (key: string, value?: string) => {
      const newParams = new URLSearchParams(location.search);

      if (value) {
        newParams.set(key, value);
      } else {
        newParams.delete(key);
      }

      navigate({ search: newParams.toString() }, { replace: true });
    },
    [location.search, navigate],
  );

  const setFilterParam: SetShopFilterParamType = useCallback(
    (filter) => {
      setSearchParam('type', filter as string);
    },
    [setSearchParam],
  );

  const setSortParam: SetShopSortParamType = useCallback(
    (sort) => {
      setSearchParam('sort', sort);
    },
    [setSearchParam],
  );

  const returnObj = useMemo(
    () => ({
      filterParam: parseFilter(filter as ShopFilterType),
      sortParam: sort || defaultShopSortOption,
      setFilterParam,
      setSortParam,
    }),
    [filter, sort, setFilterParam, setSortParam],
  );

  return returnObj;
};

export default useShopRouteParams;
